import React from 'react';
import { Backdrop, Box, Button, Typography } from '@mui/material';

const modalStyle = {
  position: 'fixed',
  margin: 'auto',
  top: '60px',
  width: 495,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  display: 'grid',
  alignContent: 'stretch',
  justifyContent: 'space - around',
  alignItems: 'start',
  justifyItems: 'center',
};

interface ModalAdminToChangeRestaurantProps {
  restaurantEnName: string;
  restaurantThName: string;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ModalAdminToChangeRestaurant(props: ModalAdminToChangeRestaurantProps) {
  const { restaurantEnName, restaurantThName, open, onConfirm, onCancel } = props;

  return (
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
      <Box sx={modalStyle} className="mt-10">
        <Typography
          sx={{ color: '#000', fontSize: '20px', width: 'inherit', fontWeight: 'bold', marginBottom: '13px' }}
          id="transition-modal-title"
          variant="h5"
          component="h2"
        >
          Remove Restaurant
        </Typography>
        <Typography variant="caption" sx={{ color: '#000', fontSize: '16px' }}>
          The restaurant {restaurantThName} ({restaurantEnName}) has active orders. Removing it will cancel all orders, and no fallback meals will be applied.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            marginTop: '30px',
            width: 'inherit',
          }}
        >
          <Button id={'btn-modal-allow-change-restaurant-yes'} color={'error'} variant="contained" onClick={onConfirm} sx={{ marginRight: '20px' }}>
            Remove Restaurant
          </Button>
          <Button id={'btn-modal-allow-change-restaurant-no'} color={'error'} variant="outlined" onClick={onCancel}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Backdrop>
  );
}
